import { render, staticRenderFns } from "./CTreeItem.vue?vue&type=template&id=978383c0&scoped=true&"
import script from "./CTreeItem.vue?vue&type=script&lang=js&"
export * from "./CTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./CTreeItem.vue?vue&type=style&index=0&id=978383c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978383c0",
  null
  
)

export default component.exports